var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToyotaHighlighted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29455",
    "data-name": "Group 29455",
    transform: "translate(-8 -742.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(8 742.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons8-toyota",
    transform: "translate(22 750.527)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50586",
    "data-name": "Path 50586",
    d: "M13.728,9C6.7,9,1,12.717,1,17.3s5.7,8.3,12.728,8.3,12.729-3.717,12.729-8.3S20.759,9,13.728,9Zm0,14.942c-5.807,0-10.515-2.974-10.515-6.641S7.922,10.66,13.728,10.66,24.243,13.634,24.243,17.3,19.535,23.942,13.728,23.942Z",
    transform: "translate(-1 -9)",
    fill: "#b3bde2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50587",
    "data-name": "Path 50587",
    d: "M21.32,12C19.486,12,18,14.974,18,18.641s1.486,6.641,3.32,6.641,3.32-2.974,3.32-6.641S23.154,12,21.32,12Zm0,11.068c-.917,0-1.66-1.982-1.66-4.427s.743-4.427,1.66-4.427,1.66,1.982,1.66,4.427S22.237,23.068,21.32,23.068Z",
    transform: "translate(-8.592 -10.34)",
    fill: "#b3bde2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50588",
    "data-name": "Path 50588",
    d: "M21,19.556c0-.007,0-.014,0-.022,0-2.445.743-4.427,1.66-4.427s1.66,1.982,1.66,4.427c0,.049,0,.1,0,.147h.006C24.332,16.469,23.971,14,22.657,14c-1.384,0-1.666,2.544-1.664,5.556Z",
    transform: "translate(-9.929 -11.233)",
    fill: "#7986cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50589",
    "data-name": "Path 50589",
    d: "M16.855,10C11.964,10,8,11.734,8,13.874s3.964,3.874,8.855,3.874,8.855-1.734,8.855-3.874S21.745,10,16.855,10Zm0,6.088c-3.667,0-6.641-1.253-6.641-2.629s2.973-2.352,6.641-2.352,6.641.977,6.641,2.352S20.522,16.088,16.855,16.088Z",
    transform: "translate(-4.126 -9.447)",
    fill: "#b3bde2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50590",
    "data-name": "Path 50590",
    d: "M4.107,20.08a5.052,5.052,0,0,1,1.691-3.6,1.771,1.771,0,0,1-.031-.27,1.91,1.91,0,0,1,.3-.984A5.463,5.463,0,0,0,3,20.08c0,3.976,5.233,5.947,9.373,6.485C7.647,25.914,4.107,23.259,4.107,20.08Zm19.07-4.858a1.91,1.91,0,0,1,.3.984,1.771,1.771,0,0,1-.031.27,5.052,5.052,0,0,1,1.691,3.6c0,3.179-3.54,5.834-8.266,6.485,4.14-.538,9.373-2.509,9.373-6.485A5.463,5.463,0,0,0,23.177,15.222Z",
    transform: "translate(-1.893 -11.779)",
    fill: "#7986cb"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToyotaHighlighted);
export default __webpack_public_path__ + "static/media/toyotaHighlighted.33d6c782e5ade659f73a44c4bb519a27.svg";
export { ForwardRef as ReactComponent };